import OpacityView from "src/components/OpacityView";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { FixedPosition } from "src/styles/position";
import { AnimatePresence } from "src/swsh-native";
import DragAndDropDisplay from "./components/DragAndDropDisplay";

const FileUploadArea = () => {
	const { theme } = useStyle();
	const isHoveringImageFile = useGatheringStore((store) => store.isHoveringImageFile);

	return (
		<AnimatePresence>
			{isHoveringImageFile && (
				<OpacityView
					style={{
						position: FixedPosition,
						width: "100%",
						height: "100%",
						backgroundColor: color.BackgroundOverlay[theme],
						backdropFilter: "blur(10px)",
						WebkitBackdropFilter: "blur(10px)",
					}}
				>
					<DragAndDropDisplay />
				</OpacityView>
			)}
		</AnimatePresence>
	);
};
export default FileUploadArea;
